import React, {useState} from 'react';
import { Modal, Container, Row, Col } from 'react-bootstrap';
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import closeicon from '../Images/close.png';
import letter from '../Images/letter.svg';
import { notification } from 'antd';
import { SmileOutlined, FrownOutlined } from '@ant-design/icons';




const ResetPasswordModal = ({isResetPasswordModalVisible, setIsResetPasswordModalVisible}) => {
    const[email, setEmail] = useState('');

    const openSuccessNotification = (message) => {
        notification.open({
          message: `${message}`,
          duration: 2,
          icon: <SmileOutlined style={{ color: '#71b324' }} />,
        });
    };
    const openErrorNotification = (message, error) => {
        notification.open({
          message: `${message}`,
          description: `${error}`,
          duration: 11,
          icon: <FrownOutlined style={{ color: 'red' }} />
      
        });
    };
    
    const triggerResetEmail = (event) => {
        firebase.auth().sendPasswordResetEmail(email)
        .then(function() {
            openSuccessNotification('Reset email sent. Check spam folder if not found')
            setIsResetPasswordModalVisible(false);
        })
        .catch(function(error) {
            openErrorNotification('Error sending reset email. Try again', error)
        });
        event.preventDefault();
      }
  return (
    <div>
        <Modal show={isResetPasswordModalVisible} onHide={() => {setIsResetPasswordModalVisible(false)}}>       
            <Modal.Body>  
                <div className='modal-outer'>
                    <div className="close-icon-div">
                        <img src={closeicon} alt="Close Icon" onClick={() => setIsResetPasswordModalVisible(false)} className="close-icon"></img>
                    </div>
                    <div className="modal-inner">
                        <h2 className="modal-header">Reset Password</h2>
                        <p className='enter-email'>Enter an email to recieve a link to reset your password</p>
                        <form onSubmit={(event) => {triggerResetEmail(event)}}>
                            <div className='signup-form'>
                                <div className='email-div'>
                                    <Container fluid className="person-container">
                                        <Row>
                                        <Col xs={1} md={1} lg={1} className="person-col">
                                            <img src={letter} alt="Email Icon" className='email-icon'></img>
                                        </Col>
                                        <Col xs={11} md={11} lg={11} className='input-col'>
                                            <input type="email" placeholder="Email" className="name-input" value={email} onChange={event => setEmail(event.target.value)} required></input>
                                        </Col>
                                        </Row>
                                    </Container>
                                </div>
                                <button className='home-sign-up email-signup' type="submit" name="submit">Reset password</button>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal.Body>  
        </Modal> 
    </div>
  )
}

export default ResetPasswordModal